module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "servicedetails"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("服务费支付状态")])], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "font-weight": "600",
      "border": "#e8e8e8 solid 1px",
      "height": "30px",
      "line-height": "30px",
      "font-size": "14px"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("订单号：" + _vm._s(_vm.detailinfo.trade_number))]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 9
    }
  }, [_vm._v("创建时间：" + _vm._s(_vm.moment(_vm.detailinfo.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("支付平台：" + _vm._s(_vm.detailinfo.trade_platform))])], 1), _vm._v(" "), _vm._l((_vm.detailinfo.TC_Orders), function(order) {
    return _c('a-row', {
      key: order,
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px",
        "font-size": "14px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center",
        "position": "relative"
      },
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))])])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v("￥" + _vm._s(order.sku_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.detailinfo.UIC_User.nick_name))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center",
        "color": "#0099FF",
        "font-weight": "700"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(_vm.status[order.order_status]))])], 1)
  }), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "border": "#e8e8e8 solid 1px",
      "border-top": "none",
      "padding": "10px",
      "font-size": "14px"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("收件人姓名：" + _vm._s(_vm.detailinfo.receiver_name))]), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("收件人手机号码：" + _vm._s(_vm.detailinfo.receiver_phone))]), _vm._v(" "), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("地址：" + _vm._s(_vm.detailinfo.receiver_address))])], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "border": "#e8e8e8 solid 1px",
      "border-top": "none",
      "padding": "10px",
      "font-size": "14px"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailinfo.remarks))])])], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "border": "#e8e8e8 solid 1px",
      "border-top": "none",
      "padding": "10px",
      "font-size": "14px"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', [_c('b', [_vm._v("服务费金额：")]), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("￥" + _vm._s(_vm.detailinfo.service_fee / 100000))])])])], 1)], 2)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f495bf0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/pricepage/servicedetails/index.vue
// module id = 2365
// module chunks = 1